import { render, staticRenderFns } from "./RolePermissionsPreview.vue?vue&type=template&id=0f621099&scoped=true"
import script from "./RolePermissionsPreview.vue?vue&type=script&lang=js"
export * from "./RolePermissionsPreview.vue?vue&type=script&lang=js"
import style0 from "./RolePermissionsPreview.vue?vue&type=style&index=0&id=0f621099&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f621099",
  null
  
)

export default component.exports